import { render, staticRenderFns } from "./ClientMedicalAssessment.vue?vue&type=template&id=34d11108&scoped=true&"
import script from "./ClientMedicalAssessment.vue?vue&type=script&lang=js&"
export * from "./ClientMedicalAssessment.vue?vue&type=script&lang=js&"
import style0 from "./ClientMedicalAssessment.vue?vue&type=style&index=0&id=34d11108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d11108",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAlert,VCard,VCardTitle,VContainer,VSimpleTable,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})
